import React, { useEffect } from 'react';
import { Authenticator, View, Image } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useNavigate } from 'react-router-dom';
import logo from './logo2.png';

const AuthenticatedRedirect = ({ user, onAuthenticated }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            return;
        }

        localStorage.setItem('userSession', JSON.stringify(user));
        onAuthenticated();

        const cognitoGroup = user?.signInDetails?.loginId ?? '';
        navigate(cognitoGroup.includes('admin') ? '/admin' : '/user', { replace: true });
    }, [navigate, onAuthenticated, user]);

    return null;
};

const CustomSignIn = ({ onAuthenticated }) => {

    return (
        <Authenticator
            components={{
                SignIn: {
                    Header() {
                        return (
                            <View textAlign="center" padding="medium">
                                <Image src={logo} alt="Custom Logo" style={{ maxWidth: '200px' }} />
                            </View>
                        );
                    },
                    Footer() {
                        return null; // Hide the "Forgot Password" and "Create Account" options
                    },
                },
            }}
            hideSignUp
        >

            {({ user }) => <AuthenticatedRedirect user={user} onAuthenticated={onAuthenticated} />}
        </Authenticator>
    );
};

export default CustomSignIn;